export default __webpack_public_path__ + "assets/Manager6.png";